<template lang="pug">
.main
  v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
    v-form(ref="form")
      v-text-field(color="primary" v-model="project.company_name" type="text" label="Company Name" @keyup.enter="validate" hint="*As shown in SSM registration" outlined :rules="rules.companyName" persistent-hint)
      v-text-field(color="primary" v-model="project.ssm_no" type="text" label="SSM number" @keyup.enter="validate" outlined :rules="rules.ssmNo")
      v-select(v-model="project.annual_sales" label="Annual sales" outlined :items="sales" item-text="text" item color="primary" return-object :rules="rules.annualSales")

      v-file-input(v-model='files[0].file' label='Photocopy of SSM' outlined multiple prepend-inner-icon='mdi-paperclip' prepend-icon='' show-size :rules="rules.document" accept="image/png, image/jpeg, image/bmp, application/pdf" hint="*Document size should be less than 10 MB" persistent-hint)
        template(v-slot:selection='{ text }')
          v-chip(small label color='primary')
            | {{ text }}

      v-file-input(v-model='files[1].file' label='Business premises license (If related)' outlined multiple prepend-inner-icon='mdi-paperclip' prepend-icon='' show-size accept="image/png, image/jpeg, image/bmp, application/pdf" hint="*Document size should be less than 10 MB" persistent-hint)
        template(v-slot:selection='{ text }')
          v-chip(small label color='primary')
            | {{ text }}

      v-file-input(v-model='files[2].file' label='Bank Statement Header (If related)' outlined multiple prepend-inner-icon='mdi-paperclip' prepend-icon='' show-size accept="image/png, image/jpeg, image/bmp, application/pdf" hint="*Document size should be less than 10 MB" persistent-hint)
        template(v-slot:selection='{ text }')
          v-chip(small label color='primary')
            | {{ text }}

      y-checkbox.mt-0(v-model="agreedTerm" :rules="rules.agreedTerm" label="I/We hereby confirm that the information provided herein is accurate, correct and complete and that the documents submitted along with this application form are genuine")

  .modals
    y-dialog(v-model='loading' persistent width='300')
      v-card(v-if="!hasResult" color='primary' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('processing_title') }}
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('processing_text') }}

      v-card(v-if="isSuccess" color='success' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('success_title') }}
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('success_text') }}

      v-card(v-if="isError" color='error' dark)
        v-card-text.pt-3
          p.mt-2 {{ $t('error_title') }}
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption {{ $t('error_text') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ValidateProjectSme',
  props: ['proceed', 'company'],
  data: () => ({
    loading: false,
    hasResult: false,
    isSuccess: false,
    isError: false,
    files: [
      { 
        file: null,
        name: 'ssm_photocopy',
        uploaded: false
      },
      { 
        file: null,
        name: 'license_photocopy',
        uploaded: false
      },
      { 
        file: null,
        name: 'bank_photocopy',
        uploaded: false
      }
    ],
    project: {
      id: null,
      company_name: '',
      ssm_no: '',
      annual_sales: null,
      documents: [],
    },
    sales: [
      {
        text: 'RM 0 - RM 100,000',
        value: 0,
        valid: true
      },
      {
        text: 'RM 100,001 - RM 200,000',
        value: 1,
        valid: true
      },
      {
        text: 'RM 200,001 - RM 300,000',
        value: 2,
        valid: true
      },
      {
        text: 'RM RM 300,001 - RM 1,000,000',
        value: 3,
        valid: true
      },
      {
        text: 'RM 1,000,001 - RM 15,000,000',
        value: 4,
        valid: true
      },
      {
        text: 'More than RM 15,000,000',
        value: 5,
        valid: true
      }
    ],
    agreedTerm: false,
    rules: {
      companyName: [
        v => !!v || 'Company name is required'
      ],
      ssmNo: [
        v => !!v || 'SSM number is required'
      ],
      annualSales: [
        v => !!v || 'Annual sales is required'
      ],
      agreedTerm: [
        v => !!v || 'You must agree with with Yezza Terms'
      ],
      document: [
        v => v !== null || 'This document is required',
        // v => !v || v.size < 10000000 || 'Document size should be less than 10 MB!'
      ]
    }
  }),
  mounted () {
    this.project.id = this.$route.query.project
  },
  watch: {
    proceed () {
      this.validate()
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    validate() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.hasResult = false
      this.isSuccess = false
      this.isError = false
      setTimeout(() => {
        this.hasResult = true
        if (!this.project.annual_sales.valid) {
          this.isError = true
          setTimeout(() => {
            this.loading = false
          }, 3000)
          return
        }
        this.isSuccess = true
        this.project.documents = []
        let hasError = false
        let uploadFileCount = 0
        this.files.forEach(item => {
          if (item.file) {
            uploadFileCount++
            var params = new FormData()
            params.append('file', item.file[0])
            this.$axios.post(`/documents/`, params)
              .then(resp => {
                const data = {
                  name: item.name,
                  document: resp.data
                }
                this.project.documents.push(data)
              })
              .catch(() => {
                hasError = true
              })
              .finally(() => {
                uploadFileCount--
                if (hasError) {
                  this.loading = false
                  this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
                } else if (uploadFileCount === 0) {
                  this.$emit('verified')
                  this.loading = false
                  this.axios.patch(`/companies/${this.company.id}/`, { extra_data: this.project })
                }
              })
          }
        })
      }, 10000)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
  "en": {
    "processing_title": "Verifying your informations...",
    "processing_text": "Please wait and do not close or refresh this page",
    "success_title": "Congratulations!",
    "success_text": "You are elegible for this program",
    "error_title": "Ops..",
    "error_text": "Sorry, you are not eligible for this program."
  }
}
</i18n>